import React from "react";
import { toggleSidebar, slideNav } from "../common/utils/common";

class Sidebar extends React.Component {
    render() {
        return (
            <div>
                <div id="site-sidebar">
                    <div className="sidebar-header">
                        <a href="https://www.immigrationdirect.com/">
                            <img src="/assets-static/images/logo-en.png" title="Immigration Direct" alt="Immigration Direct"/>
                        </a>
                    </div>
                    <nav className="sidebar-menu">

                        <a onClick={(e) => slideNav(e, 0)} id="0" className="link-primary ddm-link">Citizenship Forms</a>
                        <div className="sidebar-ddm">
                            <ul>
                                <li>
                                    <a href="https://www.immigrationdirect.com/us-citizenship-n400-preparation-service/">
                                        U.S. Citizenship (N-400)
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/citizenship-certificate-n600-preparation-service/">
                                        Citizenship Certificate (N-600)
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/replace-citizenship-certificate-n565-preparation-service/">
                                        Renew Citizenship Certificate (N-565)
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <a onClick={(e) => slideNav(e, 1)} id="1" className="link-primary ddm-link">Green Card Forms</a>
                        <div className="sidebar-ddm">
                            <ul>
                                <li>
                                    <a href="https://www.immigrationdirect.com/green-card-renewal-i90-preparation-service/">
                                        Green Card Renewal (I-90)
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/petition-for-alien-relative-i130-preparation-service/">
                                        Family Green Card (I-130)
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/remove-conditions-residence-form-i-751/">
                                        Remove Conditions (I-751)
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/adjustment-of-status-i485-preparation-service/">
                                        Adjust Status (I-485)
                                    </a>
                                </li>
                                <li>
                                    <a href="https://app.immigrationdirect.com/green-card-expiration-reminder-service/">
                                        Green Card Expiration Service
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <a onClick={(e) => slideNav(e, 2)} id="2" className="link-primary ddm-link">Other Forms</a>
                        <div className="sidebar-ddm">
                            <ul>
                                <li>
                                    <a href="https://www.immigrationdirect.com/i-765-employment-authorization-application/">
                                        EAD (Form I-765)
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/apply-deferred-action-daca-form-i-821d/">
                                        DACA (I-821D)
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <a onClick={(e) => slideNav(e, 3)} id="3" className="link-primary ddm-link">Resources</a>
                        <div className="sidebar-ddm">
                            <ul>
                                <li>
                                    <a href="https://app.immigrationdirect.com/case-status/">
                                        USCIS Case Status
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/b1-business-visa-overview/">
                                        B1 Business Visa eBook
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/b2-tourist-visa-overview/">
                                        B2 Tourist Visa eBook
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/blog/uscis-processing-times-explained/">
                                        USCIS Processing Times
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/blog/monthly-visa-bulletin-guide/">
                                        Visa Bulletin
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/blog/">Blog</a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/news/">News</a>
                                </li>
                            </ul>
                        </div>

                        <a onClick={(e) => slideNav(e, 4)} id="4" className="link-primary ddm-link">Guides</a>
                        <div className="sidebar-ddm">
                            <ul>
                                <li>
                                    <a href="https://www.immigrationdirect.com/blog/how-to-apply-for-us-citizenship/">
                                        Applying for U.S. Citizenship
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/guides/green-card-guide/">
                                        Green Card Guide
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/us-visa-application-guides/">
                                        Getting a U.S. Visa
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/blog/guidance-on-working-in-the-us/">
                                        Working in the U.S.
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/guides/green-card-renewal-explained/">
                                        Green Card Renewal
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/guides/form-n-400-naturalization/">
                                        Naturalization Guide
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/blog/us-citizenship-test-overview/">
                                        Citizenship Test
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <a onClick={(e) => slideNav(e, 5)} id="5" className="link-primary ddm-link">About Us</a>
                        <div className="sidebar-ddm">
                            <ul>
                                <li>
                                    <a href="https://www.immigrationdirect.com/immigration-lawyer-consultation/">
                                        Lawyer Consultation
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.immigrationdirect.com/contact-us/">
                                        Contact
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <a href="https://www.immigrationdirect.com/immigration-virtual-assistant/" className="link-secondary">
                            Immigration Questions
                        </a>

                        <a href="/registration/logincheck.do?next=/application-center/applicationcenter.do&amp;lang=en" className="link-secondary">My Account</a>

                    </nav>
                </div>
                <div id="faded-bg" onClick={() => toggleSidebar()}>&nbsp;</div>
            </div>
        );
    }
}

export default Sidebar;
